import React from "react";
import RiskGauge from "@/components/command/RiskGauge";

export const PanicIndexCard = ({ data, label = "Panic Risk Index", testid = "panic-index-card" }) => {
  const value = data?.panic_index ?? 0;

  return (
    <div
      className="panel p-3 flex flex-col items-center justify-center text-center min-h-[150px]"
      data-testid={testid}
    >
      <RiskGauge value={value} size={130} label={label} />
      <div className="micro-label mt-2 whitespace-nowrap">
        5-factor weighted · refreshes 6 s
      </div>
    </div>
  );
};

export default PanicIndexCard;
